type CountryProps = {
	name: string;
	code: string;
	requiredPostalCode?: boolean;
	requiredRegion?: boolean;
};

class Country {
	constructor(public _: CountryProps) {}

	get displayText() {
		return `${this._.name} (${this._.code})`;
	}
}

class CountryList {
	countries: Country[];

	constructor(countries: Country[]) {
		this.countries = countries;
	}

	filterByText(text: string) {
		return this.countries.filter((country) => {
			return `${country._.code} ${country._.name}`
				.toLowerCase()
				.includes(text.toLowerCase());
		});
	}

	getCountryByCode(code: string) {
		return this.countries.find((country) => country._.code === code);
	}
}

export { Country, CountryList };
